/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Error_Label2Inputs */

const vi_cmspostcategory_error_label2 = /** @type {(inputs: Cmspostcategory_Error_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tên chuyên mục.`)
};

/**

* @param {Cmspostcategory_Error_Label2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_error_label2 = /** @type {((inputs?: Cmspostcategory_Error_Label2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Error_Label2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_error_label2(inputs)
});
export { cmspostcategory_error_label2 as "cmsPostCategory_error_label" }